import React, { FC, useEffect } from "react";
import { message } from "antd";
import useGlobalModel from "../../model/globalModel";
import { useHistory } from "react-router-dom";
import "./Login.scss";
import { loginService } from "./LoginService";

interface ITokenLogin {
  token: string;
}
export const TokenLogin: FC<ITokenLogin> = ({ token }) => {
  const history = useHistory()
  const { user, setUser } = useGlobalModel();

  useEffect(() => {
    beforeLogin()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token])

  const beforeLogin = async () => {
    //拿到用户信息
    await loginService.getUser({ token: token }).then(result => {
      if (result.retCode === '200') {
        console.log(result.retData)
        setUser({ ...user, ...result.retData, token, loginType: 'token' })
        history.push('/')
      } else {
        message.warning("获取用户信息失败")
      }
    });

  }


  return (
    <div className="login">
      <div className="caseBlanche">
        <div className="rond">
          <div className="test"></div>
        </div>
        <div className="load">
          <p>loading</p>
        </div>
      </div>
    </div>
  )

}

export default TokenLogin;